<template>
	<div style="background-color: #F6F8F9" class="opera-cashier">
        <topNav :title="$t('memberDetailCharge_title')"
                url="/opera/member" back="true"></topNav>
		<template v-for="(item,key) in report">
			<div class="chartform">
				<table>
					<tr>
						<td colspan="2" class="title">
								<h3>{{item.hotelName}}</h3>
							<i class="iconfont icon-changfangxingbiaoqian"></i>
						</td>
					</tr>
					<tr>
            <th>{{$t('memberDetailPay_category')}}</th>
            <th>{{$t('memberDetailPay_amount')}}</th>
					</tr>
                    <tr class="sum">
						<td class="Con_tt">
              {{$t('memberDetailPay_total')}}
						</td>
						<td>
							<small>￥</small> {{item.sum}}
						</td>
					</tr>
					<template v-for="d in item.list">
					<tr class="tableCon">
						<td class="Con_tt">
							{{d.descript}}
						</td>
						<td>
							<small>￥</small>{{d.amount | toThousands}}
						</td>
					</tr>
					</template>
				</table>
			</div>
		</template>
             <nothing :condition="report != null && (report.length  == undefined || report.length == 0)"></nothing>
	</div>
</template>
<script>
import { Toast } from 'mint-ui';
import _ from 'lodash'
import nothing from "../operaCommon/nothing";
export default {
	data() {
		return {
			seachOption: {
				start: null,
				d: null,
				dateType: "month",//无用
                type: 0,
                level:''
			},
			report: {},
			shirt: {},
			user: {}
		}
	},
	mounted() {
		this.seachOption.start = this.$route.query.start;
		this.seachOption.d = this.$route.query.end;
        this.seachOption.type = this.$route.query.type;
        this.seachOption.level = this.$route.query.level;

		this.getData();
	},
	methods: {
		getData() {
			this.$http.post('/mobilepmsapi/opera/report/getMemberCardCharge', this.seachOption).then(res => {
				if (res.data.result == 0) {
					this.report = res.data.retVal;
					console.log(this.report)
				}
				else {
					Toast({
						message: res.data.msg,
						position: 'bottom',
						duration: 3000
					});
				}
			})
		}
	},
	filters: {
toThousands(num) {
        return num.toFixed(2).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
        }
	},
	components: {
nothing
	}
}
</script>
<style lang='less'>
.opera-cashier {
	.topNav {
		height: 48px;
		background-color: #fff;
		width: 100%;
		box-sizing: border-box;
		padding: 0 12px 0 0px;
		.nav {
			position: relative;
			height: 100%;
			float: left;
			z-index: 1;
			overflow: hidden;
			line-height: 48px;
			.list {
				overflow: hidden;
				height: 100%;
				line-height: 48px;
				box-sizing: border-box;
				padding-right: 16px;
				text-align: center;
				padding-left: 10px;
				background-color: #fff;
			}
			.icon-xia {
				position: absolute;
				top: 0;
				right: 0;
				line-height: 48px;
				color: #000;
				z-index: 1;
			}
		}
		.time {
			width: 30%;
			.datepickbox {
				input {
					font-size: 14px !important;
				}
			}
		}
		.hotel {
			width: 40%;
			&.show {
				overflow: visible;
				.icon-xia {
					transform: rotate(180deg);
				}
			}
		}
		.reveune {
			width: 30%;
			&.show {
				overflow: visible;
				.icon-xia {
					transform: rotate(180deg);
				}
			}
		}
	}

.chartform {
		width: 100%;
		margin: 0 auto;
		margin-top: 10px;
		box-shadow: 5px 0px 20px #ddd;
		border-radius: 3px;

		table {
			width: 100%;
			tr {
				th{width: 50%;
    height: 39px;
    background: #F69C2D;
    color: #fff;
    font-size: 12px;
    text-align: center;}
				td {
					width: 33%;
					height: 30px;
					text-align: center;
					position: relative;
					h3 {
						padding-left: 13px;
						font-size: 14px;
						text-align: left;
					}
					.iconfont {
						position: absolute;
						left: -5px;
						top: 16px;
						color: #F69C2D;
						height: 12px;
						width: 4px;
					}
                }
                .title{height:50px;}
            }
            .sum{background: #F6EF8B;}
			.tableCon {
				height: 35px;
				.Con_tt {
					color: #aaa;
					font-size: 12px;
					line-height: 20px;
					font-weight:bold;
				}
				.Con_ff {
					font-size: 22px;
					line-height: 34px;
				}
				.Con_ff small {
					font-size: 14px;
				}
			}
		}
	}
	/*.flip-list-enter {
		background-color: red;
	}*/
}
</style>



// WEBPACK FOOTER //
// memberDetailCharge.vue?307cf52c